import { combineReducers } from 'redux';

import countries from './countries';
import templates, * as fromTemplates from './templates';

export default combineReducers({ countries, templates });

export const getCountries = (state) => state.countries;
export const getTemplates = (state) =>
    fromTemplates.getTemplates(state.templates);
export const getTemplate = (state, id) =>
    fromTemplates.getTemplate(state.templates, id);
